import styled from "@emotion/styled";

export const StyledContainer = styled.div`
  border-top-left-radius: 40px;
  background: ${({ theme }) =>
    `linear-gradient(180deg, ${theme.palette.grey[100]} 0%, ${theme.palette.background.default} 300px, ${theme.palette.background.default} 100%)`};
`;
